import React from "react";

import { Navigate } from "react-router-dom";

import { useUser } from "../../contexts/UserContext";

const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useUser();

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  // Si no hay usuario, redirigir a auth
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Si hay usuario, mostrar el componente
  return children;
};

export default ProtectedRoute;
